<template>
  <div class="tw:grid tw:content-center tw:items-center tw:justify-center tw:justify-items-center tw:h-[50vh] tw:text-center">
    <Spinner size="lg" />
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import Spinner from '@/components/v2/Spinner.vue';

export default {
  name: 'Logout',
  components: { Spinner },
  async created() {
    sessionStorage.clear();
    await Auth.signOut();
  },
};
</script>
